module.exports = __webpack_public_path__ + "media/images/pages/products-225fcee6e12811d1a30e19849d4d4b46.png";